export enum RatesheetProjectTypes {
  BrandActivation = 'BRAND_ACTIVATION_PROJECT',
  General = 'GENERAL_PROJECT',
}
